import { useEffect, useContext, useCallback, useState } from 'react';
import UsersTable from './table/UsersTable';
import { Users } from 'lib/api';
import { HeaderComponent } from 'components/shared/HeaderComponent';
import { CustomTableContainer } from 'components/TransactionsSection/table/CustomTableContainer';
import { TitleTable } from 'components/TransactionsSection/table/TitleTable';
import { Button, Stack, Typography } from '@mui/material';
import { AuthContext } from 'context/auth-context';
import { UserContext } from 'context/users/userContext';
import { USERS_ACTIONS } from 'context/users/userReducer';
import { USER_ROLES } from 'helpers/constants';

export const UsersComponent = () => {
    const {
        state: { reloadUsers },
        dispatch
    } = useContext(UserContext);
    const { userInfo, businessInfo } = useContext(AuthContext);
    const [pagination, setPagination] = useState({
        page: 0,
        rowsPerPage: 10
    });

    const fetchUsers = useCallback(async () => {
        try {
            const queryParams = {
                page: pagination.page,
                limit: pagination.rowsPerPage,
                order: 'DESC'
            };
            const userList = await Users.getUsers(queryParams);
            dispatch({ type: USERS_ACTIONS.SET_USERS, payload: userList });
        } catch (error) {
            console.error(error);
        }
    }, [dispatch, pagination.page, pagination.rowsPerPage]);
    useEffect(() => {
        fetchUsers();
    }, [fetchUsers, reloadUsers]);

    return (
        <Stack minHeight="89vh" maxWidth="95vw">
            <HeaderComponent title="Users" />
            <CustomTableContainer>
                <Stack spacing={2} direction="row">
                    <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
                        <TitleTable title="All Users" />
                    </Typography>
                    {userInfo?.id_role === USER_ROLES.ADMIN && (
                        <Button
                            onClick={() => dispatch({ type: USERS_ACTIONS.SHOW_USER_FORM_MODAL })}
                            variant="contained"
                            data-testid="users-create-user-button"
                            disabled={Boolean(businessInfo?.is_frozen)}>
                            Add user
                        </Button>
                    )}
                </Stack>
                <UsersTable pagination={pagination} setPagination={setPagination} />
            </CustomTableContainer>
        </Stack>
    );
};

export default UsersComponent;
